var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgPulse = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentcolor",
  viewBox: "0 0 32 32",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M16.986 27.388c.504 1.826 3.029 1.993 3.77.249l4.103-9.668h6.876v-4h-8.2a2 2 0 0 0-1.841 1.219l-2.38 5.605-4.507-16.325c-.506-1.831-3.04-1.992-3.773-.24l-4.039 9.655H0v4h8.327a2 2 0 0 0 1.845-1.228l2.32-5.545 4.494 16.278Z"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgPulse);
export default ForwardRef;